import React from 'react'
import { usePartner } from '@@partner:helpers/hooks/auth'

import CatalogTopMenu from '@components/catalog/CatalogTopMenu'
import CategorySubMenu from '@components/catalog/category/CategorySubMenu'
import CategoryTree from '@components/catalog/category/tree/CategoryTree'

export default function CatalogCategoriesTreePage () {
  const { brandSlug } = usePartner()

  return (
    <div className="CatalogCategoriesPage">
      <h1 className="u-heading">Категории</h1>
      <CatalogTopMenu />
      <CategorySubMenu />
      <CategoryTree brandSlug={brandSlug} />
    </div>
  )
}
